import { c as _c } from "react/compiler-runtime";
import { DangerButton, PrimaryButton } from '@systemeio/ui';
import { ReactNode, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { ItemIntegrationParams, ItemIntegrationParamsProps } from './item-integration-params';
type CommonProps = {
  removeIntegration: () => Promise<void>;
  reconnectIntegration?: () => Promise<void>;
  showReconnectButton?: boolean;
  onLoading?: (loading: boolean) => void;
  additionalContent?: ReactNode;
};
type Props = ({
  email?: never;
  createdAt?: never;
  status?: never;
  customParams: ItemIntegrationParamsProps['params'];
} & CommonProps) | ({
  email: string;
  createdAt: string;
  status: string;
  customParams?: never;
} & CommonProps);
export const ItemIntegration = t0 => {
  const $ = _c(42);
  const {
    email,
    status,
    createdAt,
    customParams,
    showReconnectButton,
    removeIntegration,
    reconnectIntegration,
    onLoading,
    additionalContent
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRemoval, setIsLoadingRemoval] = useState(false);
  let t1;
  if ($[0] !== onLoading || $[1] !== reconnectIntegration || $[2] !== showReconnectButton) {
    t1 = async () => {
      if (reconnectIntegration && showReconnectButton) {
        setIsLoading(true);
        onLoading?.(true);
        await reconnectIntegration();
        setIsLoading(false);
        onLoading?.(false);
      }
    };
    $[0] = onLoading;
    $[1] = reconnectIntegration;
    $[2] = showReconnectButton;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onReconnectIntegration = t1;
  let t2;
  if ($[4] !== onLoading || $[5] !== removeIntegration) {
    t2 = async () => {
      setIsLoadingRemoval(true);
      onLoading?.(true);
      await removeIntegration();
      setIsLoadingRemoval(false);
      onLoading?.(false);
    };
    $[4] = onLoading;
    $[5] = removeIntegration;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onRemoveIntegration = t2;
  let t3;
  if ($[7] !== createdAt || $[8] !== customParams || $[9] !== email || $[10] !== status || $[11] !== t) {
    t3 = customParams ?? [{
      title: t("global.email_address"),
      value: email
    }, {
      title: t("global.created_on"),
      value: createdAt
    }, {
      title: t("global.status"),
      value: status
    }];
    $[7] = createdAt;
    $[8] = customParams;
    $[9] = email;
    $[10] = status;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <ItemIntegrationParams params={t3} />;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== additionalContent || $[16] !== t4) {
    t5 = <div className="mb-5 flex flex-col gap-2.5 lg:mb-7 lg:gap-4">{t4}{additionalContent}</div>;
    $[15] = additionalContent;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const t6 = reconnectIntegration && "justify-evenly gap-2";
  let t7;
  if ($[18] !== t6) {
    t7 = twMerge("flex justify-center", t6);
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isLoading || $[21] !== onReconnectIntegration || $[22] !== reconnectIntegration || $[23] !== showReconnectButton || $[24] !== t) {
    t8 = reconnectIntegration && showReconnectButton && <PrimaryButton onClick={() => onReconnectIntegration()} isFetching={isLoading}>{t("dashboard.user_settings.integrations_page.reconnect")}</PrimaryButton>;
    $[20] = isLoading;
    $[21] = onReconnectIntegration;
    $[22] = reconnectIntegration;
    $[23] = showReconnectButton;
    $[24] = t;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== onRemoveIntegration) {
    t9 = () => onRemoveIntegration();
    $[26] = onRemoveIntegration;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t) {
    t10 = t("dashboard.user_settings.integrations_page.disconnect");
    $[28] = t;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== isLoading || $[31] !== isLoadingRemoval || $[32] !== t10 || $[33] !== t9) {
    t11 = <DangerButton disabled={isLoading} isFetching={isLoadingRemoval} onClick={t9}>{t10}</DangerButton>;
    $[30] = isLoading;
    $[31] = isLoadingRemoval;
    $[32] = t10;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t7 || $[37] !== t8) {
    t12 = <div className={t7}>{t8}{t11}</div>;
    $[35] = t11;
    $[36] = t7;
    $[37] = t8;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t12 || $[40] !== t5) {
    t13 = <div className="mb-4 lg:mb-6">{t5}{t12}</div>;
    $[39] = t12;
    $[40] = t5;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};